import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
export function FAQ() {
  const faqs: FAQItem[] = [{
    question: '¿Es legal esta certificación?',
    answer: 'Sí, cumplimos estrictamente con todos los requisitos y normativas del Ministerio de Salud de Costa Rica. Nuestra plataforma está diseñada para asegurar que tu documentación sea válida y oficial.'
  }, {
    question: '¿Qué documentos necesito?',
    answer: 'Te enviamos una lista completa y personalizada al registrarte. Generalmente necesitarás tu cédula de identidad, patente comercial vigente y fotografías específicas de las instalaciones de gas de tu local.'
  }, {
    question: '¿Qué pasa si tengo dudas durante el proceso?',
    answer: 'No te preocupes. Nuestro equipo de expertos está disponible 24/7 a través de WhatsApp para resolver cualquier duda técnica o administrativa que tengas durante el proceso.'
  }, {
    question: '¿Garantizan la aprobación?',
    answer: 'Si tu local cumple con los requisitos físicos básicos de seguridad, garantizamos la gestión exitosa de tu certificación. Si por alguna razón imputable a nuestra gestión no se logra, te devolvemos el dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-12" data-id="element-14">
          <div className="inline-flex items-center justify-center p-3 bg-blue-50 rounded-full mb-4" data-id="element-15">
            <HelpCircle className="w-6 h-6 text-[#1e3a5f]" data-id="element-16" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-17">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-18">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden transition-all duration-200 hover:border-blue-300" data-id="element-20">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-21">
                <span className="font-bold text-gray-900 text-lg pr-8" data-id="element-22">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#f59e0b] flex-shrink-0" data-id="element-23" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-24" />}
              </button>

              <AnimatePresence data-id="element-25">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-26">
                    <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-27">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}